import type { TourStop } from "./TourMap";

export const TOUR_CSV_URL =
  "https://docs.google.com/spreadsheets/d/e/2PACX-1vSyAHmWtQKsy2SrL2JjDTKrl_PD0pfoYqGHoiEAvA5nZisvuSxfm9EVFLHmaCkLzc6JA9Y_3r8bw_ZQ/pub?gid=0&single=true&output=csv";

const cityCoordinates: Record<string, [number, number]> = {
  agen: [44.2031, 0.6164],
  alencon: [48.4329, 0.0913],
  amiens: [49.8941, 2.2958],
  angers: [47.4784, -0.5632],
  angouleme: [45.6484, 0.1562],
  annecy: [45.8992, 6.1294],
  annemasse: [46.1958, 6.2366],
  arcachon: [44.6613, -1.1721],
  arras: [50.291, 2.7775],
  aurillac: [44.9309, 2.4446],
  auxerre: [47.7982, 3.5738],
  avignon: [43.9493, 4.8055],
  "aix en provence": [43.5297, 5.4474],
  albi: [43.9298, 2.148],
  ales: [44.1276, 4.0829],
  auch: [43.6465, 0.5903],
  beaune: [47.026, 4.8403],
  bergerac: [44.8538, 0.4834],
  berck: [50.407, 1.5646],
  besancon: [47.2378, 6.0241],
  beziers: [43.3442, 3.2158],
  biarritz: [43.4832, -1.5586],
  bordeaux: [44.8378, -0.5792],
  "bourg en bresse": [46.2052, 5.2255],
  bourges: [47.081, 2.3988],
  brest: [48.3904, -4.4861],
  "brive la gaillarde": [45.1589, 1.5333],
  bussang: [47.8846, 6.8529],
  caen: [49.1829, -0.3707],
  cahors: [44.4475, 1.4419],
  calais: [50.9513, 1.8587],
  carcassonne: [43.213, 2.3491],
  cascassonne: [43.213, 2.3491],
  "carhaix plouguer": [48.2763, -3.5744],
  castellane: [43.8476, 6.512],
  castres: [43.6077, 2.2419],
  chambery: [45.5646, 5.9178],
  "charleville mezieres": [49.7625, 4.7245],
  chartres: [48.4469, 1.489],
  chateauroux: [46.8114, 1.6868],
  "chateau chinon": [47.0658, 3.9279],
  chatellerault: [46.817, 0.5452],
  cherbourg: [49.6337, -1.6221],
  "clermont ferrand": [45.7772, 3.087],
  compiegne: [49.4179, 2.8261],
  creteil: [48.7904, 2.4556],
  dieppe: [49.9229, 1.0775],
  "digne les bains": [44.0925, 6.2356],
  dijon: [47.322, 5.0415],
  dunkerque: [51.0344, 2.3768],
  epinal: [48.1737, 6.449],
  foix: [42.9649, 1.6058],
  fontainebleau: [48.4047, 2.7016],
  gap: [44.5596, 6.0798],
  geneve: [46.2044, 6.1432],
  grenoble: [45.1885, 5.7245],
  gueret: [46.1705, 1.8714],
  "ile de groix": [47.638, -3.454],
  "la rochelle": [46.1603, -1.1511],
  "la roche sur yon": [46.6705, -1.426],
  langres: [47.8625, 5.3331],
  laon: [49.5638, 3.6242],
  "le havre": [49.4944, 0.1079],
  "le mans": [48.0061, 0.1996],
  "le puy en velay": [45.0437, 3.8852],
  "les vans": [44.405, 4.1346],
  lille: [50.6292, 3.0573],
  limoges: [45.8336, 1.2611],
  "lons le saunier": [46.6746, 5.5552],
  lorient: [47.7483, -3.3702],
  lyon: [45.764, 4.8357],
  macon: [46.3069, 4.8287],
  "mantes la jolie": [48.9905, 1.7169],
  marseille: [43.2965, 5.3698],
  mende: [44.5176, 3.5016],
  metz: [49.1193, 6.1757],
  "mont de marsan": [43.8911, -0.5006],
  montelimar: [44.5588, 4.7509],
  montlucon: [46.3401, 2.6025],
  montpellier: [43.611, 3.8767],
  morlaix: [48.5775, -3.8279],
  moulins: [46.5667, 3.3333],
  mulhouse: [47.7508, 7.3359],
  nancy: [48.6921, 6.1844],
  nantes: [47.2184, -1.5536],
  nevers: [46.9896, 3.159],
  nice: [43.7102, 7.262],
  nimes: [43.8367, 4.3601],
  niort: [46.3237, -0.4648],
  orleans: [47.9029, 1.9093],
  paris: [48.8566, 2.3522],
  pau: [43.2951, -0.3708],
  perigueux: [45.1842, 0.7214],
  perpignan: [42.6887, 2.8948],
  poitiers: [46.5802, 0.3404],
  pontarlier: [46.9035, 6.3554],
  pornic: [47.1156, -2.1042],
  quimper: [47.996, -4.102],
  reims: [49.2583, 4.0317],
  rennes: [48.1173, -1.6778],
  rodez: [44.3494, 2.5759],
  roubaix: [50.6927, 3.1778],
  rouen: [49.4432, 1.0993],
  royan: [45.6285, -1.0281],
  "saint brieuc": [48.5142, -2.7658],
  "saint denis": [48.9362, 2.3574],
  "saint dizier": [48.6377, 4.947],
  "saint etienne": [45.4397, 4.3872],
  "saint gaudens": [43.1081, 0.7236],
  "saint lo": [49.1162, -1.0905],
  "saint malo": [48.6493, -2.0257],
  "saint nazaire": [47.2735, -2.2138],
  "saint quentin": [49.8489, 3.2876],
  strasbourg: [48.5734, 7.7521],
  tarbes: [43.2329, 0.0781],
  thionville: [49.3576, 6.1684],
  toulon: [43.1242, 5.928],
  toulouse: [43.6047, 1.4442],
  tours: [47.3941, 0.6848],
  troyes: [48.2973, 4.0744],
  ussel: [45.5489, 2.3122],
  valbonne: [43.641, 7.0086],
  valence: [44.9334, 4.8924],
  verdun: [49.1597, 5.3842],
  vesoul: [47.6229, 6.1557],
  vichy: [46.1286, 3.4267],
  yquebeuf: [49.603, 1.256],
};

type CsvRow = Record<string, string>;

export async function fetchTourDates(): Promise<TourStop[]> {
  const response = await fetch(TOUR_CSV_URL);

  if (!response.ok) {
    throw new Error(`Unable to fetch tour dates: ${response.status}`);
  }

  const csv = await response.text();
  const rows = parseCsv(csv);
  return rows.map(rowToTourStop).filter((stop) => stop.city && stop.date);
}

function rowToTourStop(row: CsvRow): TourStop {
  const city = getCell(row, "Ville");
  const rawDate = getCell(row, "Date");
  const parsedDate = parseSheetDate(rawDate);
  const time = parseSheetTime(rawDate);
  const address = getCell(row, "Adresse");
  const rawVenue = getCell(row, "Salle") || address;
  const isValidated = Boolean(rawVenue);
  const venueUrl = normalizeExternalUrl(getCell(row, "Lien de la salle"));
  const coordinates = readCoordinates(row) ?? cityCoordinates[normalizeCity(city)];

  return {
    city,
    isValidated,
    venue: rawVenue || "Lieu à confirmer",
    venueUrl: address && venueUrl ? venueUrl : undefined,
    date: parsedDate ? formatParsedDate(parsedDate) : rawDate,
    time,
    scheduleDateTime: parsedDate ? buildScheduleDateTime(parsedDate, time) : undefined,
    dateStatus: parsedDate ? getDateStatus(parsedDate) : "future",
    dateTimestamp: parsedDate?.getTime(),
    coordinates,
  };
}

function readCoordinates(row: CsvRow): [number, number] | undefined {
  const combinedCoordinates = readCombinedCoordinates(getCell(row, "Latitude/Longitude"));

  if (combinedCoordinates) {
    return combinedCoordinates;
  }

  const latitude = Number.parseFloat(getCell(row, "Latitude").replace(",", "."));
  const longitude = Number.parseFloat(getCell(row, "Longitude").replace(",", "."));

  if (Number.isFinite(latitude) && Number.isFinite(longitude)) {
    return [latitude, longitude];
  }
}

function readCombinedCoordinates(value: string): [number, number] | undefined {
  const [rawLatitude, rawLongitude] = value.split(",").map((coordinate) => coordinate.trim());

  if (!rawLatitude || !rawLongitude) {
    return;
  }

  const latitude = Number.parseFloat(rawLatitude);
  const longitude = Number.parseFloat(rawLongitude);

  if (Number.isFinite(latitude) && Number.isFinite(longitude)) {
    return [latitude, longitude];
  }
}

function getCell(row: CsvRow, key: string) {
  return row[key]?.trim() ?? "";
}

function normalizeExternalUrl(value: string) {
  if (!value) {
    return;
  }

  if (/^https?:\/\//i.test(value)) {
    return value;
  }

  return `https://${value}`;
}

function parseCsv(csv: string): CsvRow[] {
  const [headers = [], ...rows] = parseCsvRows(csv);

  return rows.map((row) =>
    Object.fromEntries(headers.map((header, index) => [header.trim(), row[index]?.trim() ?? ""])),
  );
}

function parseCsvRows(csv: string): string[][] {
  const rows: string[][] = [];
  let row: string[] = [];
  let cell = "";
  let insideQuotes = false;

  for (let index = 0; index < csv.length; index += 1) {
    const char = csv[index];
    const nextChar = csv[index + 1];

    if (char === '"' && nextChar === '"') {
      cell += '"';
      index += 1;
      continue;
    }

    if (char === '"') {
      insideQuotes = !insideQuotes;
      continue;
    }

    if (char === "," && !insideQuotes) {
      row.push(cell);
      cell = "";
      continue;
    }

    if ((char === "\n" || char === "\r") && !insideQuotes) {
      if (char === "\r" && nextChar === "\n") {
        index += 1;
      }
      row.push(cell);
      rows.push(row);
      row = [];
      cell = "";
      continue;
    }

    cell += char;
  }

  if (cell.length > 0 || row.length > 0) {
    row.push(cell);
    rows.push(row);
  }

  return rows.filter((cells) => cells.some((value) => value.trim()));
}

function parseSheetDate(value: string) {
  const datePart = value.split(" ")[0];

  if (!datePart) {
    return;
  }

  const [day, month, year] = datePart.split("/").map(Number);

  if (!day || !month || !year) {
    return;
  }

  return new Date(year, month - 1, day);
}

function parseSheetTime(value: string) {
  const timePart = value.trim().split(/\s+/).slice(1).join(" ");

  if (!timePart) {
    return;
  }

  const [hoursPart, minutesPart] = timePart.split(/[:h.]/i);
  const hours = Number(hoursPart);
  const minutes = Number(minutesPart);

  if (!Number.isFinite(hours) || !Number.isFinite(minutes)) {
    return;
  }

  if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
    return;
  }

  if (hours === 0 && minutes === 0) {
    return;
  }

  return `${hours}h${String(minutes).padStart(2, "0")}`;
}

function buildScheduleDateTime(date: Date, time?: string) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const datePart = `${year}-${month}-${day}`;

  if (!time) {
    return datePart;
  }

  const match = /^(\d+)h(\d{2})$/.exec(time);

  if (!match?.[1] || !match[2]) {
    return datePart;
  }

  const hours = match[1].padStart(2, "0");
  const minutes = match[2];

  return `${datePart}T${hours}:${minutes}`;
}

function formatParsedDate(date: Date) {
  return new Intl.DateTimeFormat("fr-FR", {
    day: "numeric",
    month: "short",
    year: "numeric",
  }).format(date);
}

function getDateStatus(date: Date): TourStop["dateStatus"] {
  const today = new Date();
  const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime();
  const dateStart = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  if (dateStart.getTime() < todayStart) {
    return "past";
  }

  if (dateStart.getTime() === todayStart) {
    return "current";
  }

  return "future";
}

function normalizeCity(city: string) {
  return city
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[’']/g, " ")
    .replace(/\?/g, "")
    .replace(/\s+/g, " ")
    .trim();
}
